import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CSForm } from 'src/app/shared/models/cs-form.model';
import { CSFormService } from 'src/app/shared/services/cs-form.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { AuthService } from '../account/auth.service';
import { User } from '../account/user.model';

@Component({
    selector: 'app-forms',
    templateUrl: './forms.component.html',
    styleUrls: ['./forms.component.scss'],
    standalone: false
})
export class FormsComponent implements OnInit, AfterViewInit {
  isLoading: boolean = true;
  forms: CSForm[] = [];
  user: string;
  User: User = null;

  constructor(
    public globalService: GlobalService,
    private formService: CSFormService,
    private authService: AuthService,
    private _router: Router
  ) {}

  async ngOnInit() {
    this.User = await this.authService.autoLogin(1);
    if (this.User != null)
    {
      this.user = this.User.id;
    }
    else
    {
      this.isLoading = false;
      this._router.navigate([this.globalService.subdomain + '/login']);
    }

    this.forms = await this.formService.getFormsByUser(this.user);
    this.forms = this.forms.filter(
      (a) => a.deleted == false && a.displayInMenu == true
    );

    this.isLoading = false;
  }

  ngAfterViewInit() {
    setTimeout(() => {
    this.globalService.title.push(this.globalService.screenHeader);
    this.globalService.screenHeader = this.globalService.Get('FORMS');
    });
  }        

  gotoForm(formId: number) {
    this._router.navigate(['/formrender/' + formId]);
  }
}
